import React from "react";
import { Box, Text, Layer, Button } from "grommet";
import PageMainCanvas from "../mainpage/PageMainCanvas";
import { MdLibraryBooks } from "react-icons/md";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import useBook from "../../hooks/useBook";

import { useRecoilState } from "recoil";
import BookUnitCard from '../maincomp/BookUnitCard';
import SearchRedbookInstModal from "./modal/SearchRedbookInst";
import { Close } from "grommet-icons";
import { libraryBooks, keepRedbooksR } from "../../recoils/library";

const PageRedbookMain = () => {
    const [redbooks, setRedbooks] = React.useState<any>([]);
    const [readyRedbooks, setReadyRedbooks] = React.useState(false);
    const [keepRedbooks, setKeepRedbooks] = useRecoilState(keepRedbooksR);
    const [redbooksInLibrary, setRedbooksInLibrary] = useRecoilState(libraryBooks);

    const getRedbooks = async () => {
        const res = await useBook.getBookList("redbook");
        //console.log("redbooks in PageRedbookMain", res)
        if(res) return res.books
    }
    React.useEffect(()=>{
        setReadyRedbooks(false);
        if(keepRedbooks){
            setRedbooks(redbooksInLibrary)
            setReadyRedbooks(true);
        } else {
            getRedbooks().then((res)=>{
                setRedbooks(res);
                setRedbooksInLibrary(res);
                setKeepRedbooks(true)
                setReadyRedbooks(true);
            })
        }
    },[])

    const ARedbook = (props:any) => {
        let a_book = props.book;
        // console.log("a_book in PageRedbookMain", a_book)

        return(
            <Box style={{maxWidth:"1000px", minWidth:"500px"}}
             flex={false}
                align='center' justify='start'>
                <BookUnitCard book={a_book}/>
            </Box>
        )
    }
    const [searchInst, setSearchInst] = React.useState(false);


    return (
        <Box width="full" height="full">
            <PageMainCanvas>
                <Box
                    direction="row"
                    align="center"
                    width="full"
                    style={{ minHeight: "50px", maxHeight: "50px" }}
                >
                    <MdLibraryBooks size="30px" />
                    <Text size="20px" margin={{ left: "10px" }}>
                        직원록
                    </Text>
                </Box>
                <Box
                    align="end"
                    justify="center"
                    pad={{ vertical: "10px", horizontal: "20px" }}
                    direction="column"
                >
                    <Box
                        direction="row"
                        align="center"
                        justify="center"
                        onClick={() => setSearchInst(true)}
                        focusIndicator={false}
                        hoverIndicator
                    >
                        <Box
                            direction="row"
                            align="center"
                            justify="center"
                            width="150px"
                        >
                            <HiOutlineBuildingOffice
                                size="15px"
                                color="black"
                            />
                            <Text
                                size="15px"
                                color="black"
                                margin="10px"
                                weight="bold"
                            >
                                기관 검색
                            </Text>
                        </Box>

                        {/* <SearchPerson /> */}
                    </Box>
                </Box>
                {readyRedbooks ?
                    <Box
                        height="95%"
                        width="full"
                        overflow={"auto"}
                        align="center"
                    >
                        {redbooks.map((r: any) => (
                            <ARedbook book={r} key={r.book_id} />
                        ))}
                    </Box>: <Box width="full" height="full" align="center" justify="center">
                        <Text size='15px'>자료 불러오는 중...</Text>
                    </Box>
                }
                {searchInst && (
                    <Box
                        direction="column"
                        background="rgba(255,255,255,0.5)"
                        alignSelf="center"
                        align="center"
                        justify="center"
                    >
                        <Layer
                            onClickOutside={() => setSearchInst(false)}
                            onEsc={() => setSearchInst(false)}
                            modal
                            full
                        >
                            <Box
                                align="start"
                                justify="start"
                                alignSelf="center"
                                width="full"
                                height="full"
                            >
                                <Box
                                    margin={{ top: "50px" }}
                                    alignSelf="end"
                                    hoverIndicator
                                    focusIndicator={false}
                                    onClick={() => setSearchInst(false)}
                                    height="50px"
                                >
                                    <Button
                                        size="15px"
                                        icon={<Close size="15px" />}
                                        onClick={() => setSearchInst(false)}
                                    />
                                </Box>
                                <Box
                                    width="90%"
                                    height="80%"
                                    align="center"
                                    alignSelf="center"
                                >
                                    <SearchRedbookInstModal />
                                </Box>
                            </Box>
                        </Layer>
                    </Box>
                )}
            </PageMainCanvas>
        </Box>
    );
};

export default PageRedbookMain;
